import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {environment} from '../../../environments/environment';

/**
 * Холст (whiteboard): доступ в не-production сборках и у компании NPM (platform owner).
 */
@Injectable()
export class WhiteboardAccessGuard {

    constructor(
        private readonly auth: AuthService,
        private readonly router: Router
    ) {
    }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        if (!environment.production) {
            return true;
        }

        const isNpm = !!this.auth.auth?.company?.is_platform_owner_company;
        if (isNpm) {
            return true;
        }

        this.router.navigate(['404']);
        return false;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(childRoute, state);
    }
}
